module.exports = __webpack_public_path__ + "static/media/mobile-development.a8707dd1.svg";